var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1A5C4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_61543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_61543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7355 27.9995L9.1355 20.3995L11.0355 18.4995L16.7355 24.1995L28.9688 11.9661L30.8688 13.8661L16.7355 27.9995Z",
    fill: "#D0F19E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperCompleted);
export default __webpack_public_path__ + "static/media/stepper-completed.371763b4b762504316898fb459b69bdb.svg";
export { ForwardRef as ReactComponent };